import type { SVGProps } from 'react';
const SvgAccountBalance = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#account_balance_svg__a)">
      <path d="M7 10H4v7h3v-7ZM13.5 10h-3v7h3v-7ZM22 19H2v3h20v-3ZM20 10h-3v7h3v-7ZM12 1 2 6v2h20V6L12 1Z" />
    </g>
    <defs>
      <clipPath id="account_balance_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAccountBalance;
